import { RootState } from 'editor/src/store/index';

const isPersonalizationLockElementsAllowed = (state: RootState) => state.hostSettings.allowPersonalizationLock;

export default isPersonalizationLockElementsAllowed;
